<template>
  <div
    :class="{
      'shaft-layout': true,
      'show-for-medium': hamburgerOpen,
      'shaft-layout--dashboard' : isDashboard
    }"
  >
    <div class="shaft-layout__header header-nav-wrapper show-for-medium">
      <header class="header-nav">
        <div class="header-nav__left">
          <div class="hide-for-large">
            <button
              type="button"
              @click="hamburgerOpen = true"
            >
              <HamburgerSvg />
            </button>
          </div>

          <div
            v-if="currentOrganisation"
            class="show-for-large"
          >
            <Popper
              v-model:open="menuOpen"
              placement="bottom-start"
            >
              <div class="menu menu--dropdown">
                <ul class="menu__items">
                  <li class="menu-item menu-item--dropdown">
                    <router-link
                      class="menu-item__link"
                      :to="{ name: shaftData.name, params: { organisationId } }"
                    >
                      <UseSvg
                        class="icon icon--back-organisation"
                        name="arrow_left_16"
                      />
                      <div class="menu-item__label">
                        {{ currentOrganisation.name }}
                      </div>
                    </router-link>
                  </li>
                  <li><hr class="menu__divider"></li>
                  <template
                    v-for="division in divisionsWithOperations"
                    :key="division.name"
                  >
                    <li class="menu__section-title typo-tiny">
                      {{ division.name }}
                    </li>

                    <!-- Shaft v2-->
                    <template v-if="isShaftV2">
                      <li
                        v-for="shaft in division.shafts_v2_shafts"
                        :key="shaft.id"
                        class="menu-item menu-item--dropdown"
                      >
                        <router-link
                          class="menu-item__link"
                          :to="{ name: shaftData.dashboard, params: { organisationId, shaftId: shaft.id } }"
                          @click.passive="closeMenus"
                        >
                          <div class="menu-item__label">
                            {{ shaft.name }}
                          </div>
                        </router-link>
                      </li>
                    </template>

                    <!-- Shaft v1-->
                    <template v-if="!isShaftV2">
                      <li
                        v-for="mine in division.mines"
                        :key="mine.id"
                        class="menu-item menu-item--dropdown menu-item--no-hover"
                      >
                        <div class="menu-item--group menu-item--no-hover">
                          <div class="menu__section-title typo-tiny menu-item--indented">
                            {{ mine.name }}
                          </div>
                          <router-link
                            v-for="shaft in mine.shafts"
                            :key="shaft.id"
                            class="menu-item__link menu-item--hover"
                            :to="{ name: shaftData.dashboard, params: { organisationId, shaftId: shaft.id } }"
                            @click.passive="closeMenus"
                          >
                            <div class="menu-item__label">
                              {{ shaft.name }}
                            </div>
                          </router-link>
                        </div>
                      </li>
                      <br>
                    </template>
                  </template>
                </ul>
              </div>

              <template #trigger>
                <div class="operation-dropdown typo-list-item">
                  <div
                    v-if="currentOrganisation"
                    class="operation-dropdown__logo"
                  >
                    <OrganisationLogo
                      :organisation="currentOrganisation"
                      :size="32"
                    />
                  </div>
                  <div
                    v-if="currentShaft"
                    class="operation-dropdown__name"
                  >
                    {{ currentShaft.name }}
                  </div>
                  <div class="operation-dropdown__icon">
                    <UseSvg
                      class="icon icon--small"
                      name="arrow_down_16"
                    />
                  </div>
                </div>
              </template>
            </Popper>
          </div>
        </div>

        <div
          v-if="currentShaft"
          class="header-nav__center header-nav__center--left-align hide-for-large"
        >
          <h1 class="header-nav__title typo-ignore typo-nav-item">
            {{ currentShaft.name }}
            <template v-if="activeMenuItem">
              <span> / </span>
              {{ activeMenuItem.label }}
            </template>
          </h1>
        </div>

        <div class="header-nav__center show-for-large">
          <div class="menu">
            <ul class="menu__items">
              <li
                v-for="item of mainNavItems"
                :key="item.label"
                :class="{'menu-item': true, 'hide': item?.hide }"
              >
                <router-link
                  v-if="!item?.hide"
                  :activeClass="item.exact ? '' : 'menu-item__link--active'"
                  :class="{
                    'menu-item__link': true,
                    'menu-item__link--active': item.active,
                  }"
                  :exactActiveClass="item.exact ? 'menu-item__link--active' : ''"
                  :to="item.to"
                >
                  <div class="menu-item__label">
                    {{ item.label }}
                  </div>
                </router-link>
              </li>
            </ul>
          </div>
        </div>

        <div class="header-nav__right">
          <UserAdminNavigation
            v-if="currentShaft && adminMenuItems"
            :adminMenuItems="adminMenuItems"
            :currentUser="currentUser?.full_name"
            :policy="currentShaft.policy"
          />
        </div>
      </header>
    </div>
    <router-view />
  </div>

  <div :class="{ 'mobile-menu-container hide-for-large': true, 'mobile-menu-container--shown': hamburgerOpen }">
    <div
      class="mobile-menu-overlay"
      @click="hamburgerOpen = false"
    />
    <div class="mobile-menu">
      <div class="mobile-menu__header">
        <div
          class="mobile-menu__close"
          @click="hamburgerOpen = false"
        >
          <CloseSvg />
        </div>
      </div>

      <div class="mobile-menu__menu">
        <div class="menu menu--hamburger">
          <ul class="menu__items">
            <li class="menu-item typo-list-item menu-item--hamburger">
              <router-link
                class="menu-item__link"
                :to="{ name: shaftData.name, params: { organisationId } }"
              >
                <div class="menu-item__label-icon">
                  <UseSvg
                    class="icon icon--small"
                    name="arrow_left_16"
                  />
                </div>
                <div class="menu-item__label">
                  {{ currentOrganisation && currentOrganisation.name }}
                </div>
              </router-link>
            </li>
          </ul>
        </div>

        <div class="menu menu--hamburger">
          <ul class="menu__items">
            <li class="menu-item menu-item--hamburger">
              <Popper
                v-model:open="menuOpen"
                placement="bottom-end"
              >
                <div class="menu menu--dropdown">
                  <ul
                    v-if="currentOrganisation"
                    class="menu__items"
                  >
                    <template
                      v-for="division in divisionsWithOperations"
                      :key="division.name"
                    >
                      <li class="menu__section-title typo-tiny">
                        {{ division.name }}
                      </li>
                      <!-- Shaft v2-->
                      <template v-if="isShaftV2">
                        <li
                          v-for="shaft in division.shafts_v2_shafts"
                          :key="shaft.id"
                          class="menu-item typo-list-item menu-item--dropdown"
                        >
                          <router-link
                            class="menu-item__link"
                            :to="{ name: shaftData.dashboard, params: { organisationId, shaftId: shaft.id } }"
                            @click.passive="closeMenus"
                          >
                            <div class="menu-item__label">
                              {{ shaft.name }}
                            </div>
                          </router-link>
                        </li>
                      </template>

                      <!-- Shaft v1-->
                      <template v-if="!isShaftV2">
                        <li
                          v-for="mine in division.mines"
                          :key="mine.id"
                          class="menu-item typo-list-item menu-item--dropdown menu-item--no-hover"
                        >
                          <div class="menu-item--group menu-item--no-hover">
                            <div class="menu__section-title typo-tiny menu-item--indented">
                              {{ mine.name }}
                            </div>
                            <router-link
                              v-for="shaft in mine.shafts"
                              :key="shaft.id"
                              class="menu-item__link menu-item--hover"
                              :to="{ name: shaftData.dashboard, params: { organisationId, shaftId: shaft.id } }"
                              @click.passive="closeMenus"
                            >
                              <div class="menu-item__label">
                                {{ shaft.name }}
                              </div>
                            </router-link>
                          </div>
                        </li>
                        <br>
                      </template>
                    </template>
                  </ul>
                </div>

                <template #trigger>
                  <div
                    v-if="currentOrganisation"
                    class="operation-dropdown typo-list-item"
                  >
                    <div class="operation-dropdown__logo">
                      <OrganisationLogo :organisation="currentOrganisation" />
                    </div>
                    <div
                      v-if="currentShaft"
                      class="operation-dropdown__name"
                    >
                      {{ currentShaft.name }}
                    </div>
                    <div class="operation-dropdown__icon">
                      <UseSvg
                        class="icon icon--small"
                        name="arrow_down_16"
                      />
                    </div>
                  </div>
                </template>
              </Popper>
            </li>
          </ul>
        </div>

        <div class="menu menu--hamburger">
          <ul class="menu__items">
            <li
              v-for="item of mainNavItems"
              :key="item.label"
              :class="{'menu-item menu-item--hamburger': true, 'hide': item?.hide}"
            >
              <router-link
                v-if="!item?.hide"
                class="menu-item__link"
                :to="item.to"
                @click.passive="closeMenus"
              >
                <div class="menu-item__label">
                  {{ item.label }}
                </div>
              </router-link>
            </li>
          </ul>
        </div>

        <div class="menu menu--hamburger hide-for-medium">
          <ul class="menu__items">
            <li
              v-for="item of hamburgerMenuItems"
              :key="item.label"
              class="menu-item menu-item--hamburger"
            >
              <router-link
                v-if="item.to"
                class="menu-item__link"
                :to="item.to"
                @click.passive="closeMenus"
              >
                <div class="menu-item__label">
                  {{ item.label }}
                </div>
              </router-link>
              <a
                v-else
                class="menu-item__link"
                :href="item.path || 'javascript:void(0);'"
              >
                <div class="menu-item__label">
                  {{ item.label }}
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <Footer />
</template>

<script>
export default { name: 'ShaftLayout' };
</script>

<script setup>
import { computed, inject, onMounted, provide, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import I18n from 'i18n-js';

// Utils
import { profileMenuItems } from '@/functions/navigation';
import { useShaft, useShaftV2 } from '@/functions/use_remote_object';
import onAppEvent from '@/functions/on_app_event';
import useAjax from '@/functions/use_ajax';
import isDesktop from '@/functions/responsive';

// Components
import Footer from '@/components/generic/footer.vue';
import UserAdminNavigation from '@/components/navigation/user_admin_navigation.vue';
import OrganisationLogo from '@/components/organisations/organisation_logo.vue';
import Popper from '@/components/generic/popper.vue';
import UseSvg from '@/components/generic/use_svg.vue';

// Icons
import CloseSvg from '@/images/close.svg';
import HamburgerSvg from '@/images/hamburger.svg';

const props = defineProps({
  organisationId: { type: String, required: true },
  shaftId: { type: String, required: true },
  inspectionId: { type: String, required: false, default: null },
  jobId: { type: String, required: false, default: null },
  scope: { type: String, required: false, default: null },
  elementType: { type: String, required: false, default: null },
  memberId: { type: String, required: false, default: null },
  issueType: { type: String, required: false, default: null },
  setNumber: { type: String, required: false, default: null },
  stationId: { type: String, required: false, default: null },
  heavyMobileEquipmentId: { type: String, required: false, default: null },
  category: { type: String, required: false, default: null },
  setGroupId: { type: String, required: false, default: null },
  issueId: { type: String, required: false, default: null },
  setId: { type: String, required: false, default: null },
});

const ajax = useAjax();
const route = useRoute();
const currentUser = inject('currentUser');

const currentOrganisation = inject('currentOrganisation');
const menuOpen = ref(false);
const hamburgerOpen = ref(false);
const divisionsWithOperations = ref(null);

const routerNameList = {
  shaft: {
    dashboard: ['shaftDashboards', 'shaftDashboard'],
    shaft_condition: ['shaftConditions', 'shaftCondition'],
    inspections: ['shaftInspections', 'shaftInspection'],
    jobs: ['shaftJobs', 'shaftJob'],
  },
  shaftV2: {
    dashboard: ['shaftV2Dashboards', 'shaftV2Dashboard'],
    inspections: ['shaftV2Inspections', 'shaftV2Inspection'],
    issues: [
      'shaftV2Issues',
      'shaftV2Issue',
      'shaftV2IssuesTypeHmes',
      'shaftV2IssuesTypeHme',
      'shaftV2IssuesTypeSets',
      'shaftV2IssuesTypeSet',
      'shaftV2IssuesTypeStations',
      'shaftV2IssuesTypeStation'
    ],
  }
};

const isShaftV2 = computed(() => route.path.includes('shafts_v2'));

const shaftData = computed(() => {
  if (isShaftV2.value) {
    return { name: 'shafts_v2', dashboard: 'shaftV2Dashboard', url: 'shafts_v2/shafts' };
  } else {
    return { name: 'shafts', dashboard: 'shaftDashboard', url: 'shafts' };
  }
});

const currentShaft = isShaftV2.value ? useShaftV2(props) : useShaft(props);

provide('currentShaft', currentShaft);

const adminMenuItems = computed(() => {
  if (!currentShaft.value) return null;

  let items = [];

  if (currentShaft.value?.policy?.manage_users) {
    items.push({
      label: I18n.t('nav.manage_users'),
      to: { name: 'allUsersScoped', params: { type: shaftData.value.name } }
    });
  }

  if (currentShaft.value?.policy?.edit) {
    !isShaftV2.value && items.push(
      {
        label: I18n.t('nav.edit_shaft'),
        to: { name: 'editShaft' },
      },
      {
        label: I18n.t('nav.definition'),
        to: { name: 'shaftDefinition' }
      }
    );

    isShaftV2.value && items.push({
      label: I18n.t('nav.configuration'),
      to: {
        name: isDesktop() ? 'shaftV2ConfigurationShafts' : 'shaftV2Configuration',
        params: {
          organisationId: props.organisationId,
          shaftId: props.shaftId,
        }
      },
    });
  }

  return items;
});

const mainNavItems = computed(() => {
  if (isShaftV2.value) {
    return [
      { label: I18n.t('nav.dashboard'), to: { name: 'shaftV2Dashboard' }, exact: true, active: routerNameList.shaftV2.dashboard.includes(route.name) },
      { label: I18n.t('nav.inspections'), to: { name: 'shaftV2Inspections', params: { scope: 'inspections'} }, active: routerNameList.shaftV2.inspections.includes(route.name) },
      { label: I18n.t('nav.issues'), to: { name: 'shaftV2IssuesOverview', params: { issueType: 'overview' } }, active: routerNameList.shaftV2.issues.includes(route.name) },
      { label: I18n.t('nav.tasks'), to: { name: 'shaftV2Tasks' } }
    ];
  } else {
    return [
      { label: I18n.t('nav.dashboard'), to: { name: 'shaftDashboard' }, exact: true, active: routerNameList.shaft.dashboard.includes(route.name) },
      { label: I18n.t('nav.shaft_condition'), to: { name: 'shaftCondition' }, active: routerNameList.shaft.shaft_condition.includes(route.name) },
      { label: I18n.t('nav.inspections'), to: { name: 'shaftInspections', params: { scope: 'inspections'} }, active: routerNameList.shaft.inspections.includes(route.name) },
      { label: I18n.t('nav.maintenance'), to: { name: 'shaftJobs', params: { scope: 'jobs'} }, active: routerNameList.shaft.jobs.includes(route.name) },
    ];
  }
});

const activeMenuItem = computed(() => {
  let matched = route.matched;
  return mainNavItems.value
    .find(item => matched.find(r => r.name === item.to.name));
});

const hamburgerMenuItems = computed(() => [
  ...adminMenuItems.value || [],
  ...profileMenuItems(I18n),
]);

const isDashboard = computed(() => route.name === 'shaftDashboard' || route.name === 'shaftV2Dashboard');

onMounted(() => {
  loadShafts();
});

onAppEvent('hamburgerOpen', () => hamburgerOpen.value = true);

watch(() => props.shaftId, loadShafts);

async function loadShafts() {
  let { ok, data } = await ajax(`/organisations/${props.organisationId}/${shaftData.value.url}`);
  if (ok) {
    divisionsWithOperations.value =  data.divisions;
  }
}

function closeMenus() {
  hamburgerOpen.value = false;
  menuOpen.value = false;
}
</script>
